import ModalManager from "../functions/scripts/modals";

export const modalManagerObject = new ModalManager({
    activeMode: 'active-mode',
    fadeInTimeout: 250,
    fadeOutTimeout: 300,
});
